import CamposTorneoSede from '../campos/CamposTorneoSede.js';
import TablaTorneoSedes from '../tablas/TablaTorneoSedes.js';
import * as Campos from '../../constantes/Campos.js';

// Funciones para CuadroEditableLista

export const armarFilasTabla = (lista, idElegido, onEditarItem, onEliminarItem) => {
  return (
    <TablaTorneoSedes
      lista={lista}
      idElegido={idElegido}
      onEditarItem={onEditarItem}
      onEliminarItem={onEliminarItem}
    />
  );
};

export const OrdenarLista = (itemA, itemB) => {
  const nombreA = itemA.pais?.nombre || '';
  const nombreB = itemB.pais?.nombre || '';
  return nombreA.localeCompare(nombreB);
};

// Funciones para EditarItemLista

export const CamposEdicion = (idPadre, item, editar, actualizar, onCampoChange) => {
  return (
    <CamposTorneoSede
      idPadre={idPadre}
      item={item}
      editar={editar}
      actualizar={actualizar}
      onCampoChange={onCampoChange}
    />
  );
};

export const OnCampoChange = (item, campo, valor) => {
  switch (campo) {
    case Campos.TorneoSede.PAIS: {
      return { ...item, pais: valor };
    }
    default: {
      throw new Error('Campo ' + campo + ' no definido');
    }
  }
};

export const ValidarItemGrabar = (item) => {
  let error = '';
  if (!item) {
    error = 'No se informaron datos para la sede';
  } else if (!item.pais) {
    error = 'Debe seleccionar el país sede';
  }
  return error;
};
